<template>
  <div>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#427D2D" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-layout wrap justify-start pa-5>
          <v-flex xs12>
            <v-layout wrap justify-space-between align-center>
              <v-flex xs12 sm6 md6 lg6>
                <span class="heading">Snake Bite Alerts</span>
                <!-- <span v-if="unreadCount > 0" class="unread-pill ml-3">
                  {{ unreadCount }} new
                </span> -->
                <div class="pt-1">
                  <span class="subtext" v-if="isStateView">
                    State wide view of every reported incident and how each district responded
                  </span>
                  <span class="subtext" v-else>
                    Incidents reported in your district. Open an alert to find the nearest
                    hospital and record the action you take.
                  </span>
                </div>
              </v-flex>
              <v-flex xs12 sm6 md6 lg6 pt-3 pt-sm-0 class="text-sm-right">
                <v-btn small outlined color="#427D2D" @click="getData()">
                  <v-icon small left>mdi-refresh</v-icon>
                  <span class="btntext">Refresh</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- filters -->
          <v-flex xs12 pt-4>
            <v-layout wrap justify-start>
              <v-flex xs12 sm6 md3 lg3 pr-md-2 pb-2>
                <v-menu
                  v-model="menuFrom"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fromDate"
                      placeholder="From Date"
                      clearable
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="fromDate" @input="menuFrom = false"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm6 md3 lg3 pr-md-2 pb-2>
                <v-menu
                  v-model="menuTo"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="toDate"
                      placeholder="To Date"
                      clearable
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="toDate" @input="menuTo = false"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm6 md3 lg2 pr-md-2 pb-2>
                <v-select
                  v-model="status"
                  :items="statusOptions"
                  placeholder="Status"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-flex>

              <v-flex xs12 sm6 md3 lg2 pr-md-2 pb-2 v-if="isStateView">
                <v-select
                  v-model="district"
                  :items="districtOptions"
                  placeholder="District"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-flex>

              <v-flex xs12 sm6 md3 lg2 pb-2>
                <v-text-field
                  v-model="keyword"
                  placeholder="Search victim"
                  outlined
                  dense
                  clearable
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- list -->
          <v-flex xs12 pt-4 v-if="rows && rows.length > 0">
            <v-card outlined>
              <div style="overflow-x: auto">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left tablehead">Reported</th>
                        <th class="text-left tablehead">Victim</th>
                        <th class="text-left tablehead">Phone</th>
                        <th class="text-left tablehead">District</th>
                        <th class="text-left tablehead">Status</th>
                        <th class="text-left tablehead">First Response</th>
                        <th class="text-left tablehead">Actions Logged</th>
                        <th class="text-left tablehead">View</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, index) in rows"
                        :key="index"
                        style="cursor: pointer"
                        :class="{ 'unread-row': row.isUnread }"
                        @click="openAlert(row)"
                      >
                        <td class="tableitems" style="white-space: nowrap">
                          {{ formatDateTime(row.reporteddate) }}
                        </td>
                        <td class="tableitems" style="white-space: nowrap">
                          <v-icon
                            v-if="row.isUnread"
                            x-small
                            color="#d32f2f"
                            class="mr-1"
                            >mdi-circle</v-icon
                          >
                          {{ row.name || "-" }}
                        </td>
                        <td class="tableitems" style="white-space: nowrap">
                          {{ row.phone || "-" }}
                        </td>
                        <td class="tableitems" style="white-space: nowrap">
                          {{ row.Districtname || "-" }}
                        </td>
                        <td class="tableitems" style="white-space: nowrap">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                v-bind="attrs"
                                v-on="on"
                                :class="['status-chip', statusClass(displayStatus(row))]"
                              >
                                {{ displayStatus(row) }}
                              </span>
                            </template>
                            <span>{{ statusTooltip(row) }}</span>
                          </v-tooltip>
                        </td>
                        <td class="tableitems" style="white-space: nowrap">
                          <span v-if="row.responseTime !== null && row.responseTime !== undefined">
                            {{ humanize(row.responseTime) }}
                          </span>
                          <span v-else class="pending-text">Awaiting</span>
                        </td>
                        <td class="tableitems" style="white-space: nowrap">
                          {{ row.actionCount || 0 }}
                        </td>
                        <td style="white-space: nowrap">
                          <v-icon small color="success" @click.stop="openAlert(row)">
                            mdi-eye
                          </v-icon>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-card>
          </v-flex>

          <v-flex xs12 pt-16 v-else>
            <v-layout wrap justify-center>
              <v-flex xs12 class="text-center">
                <v-icon size="48" color="#c8d6c8">mdi-bell-off-outline</v-icon>
                <div class="nodata pt-2">No Alerts Found !</div>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 pt-4 v-if="rows && rows.length > 0">
            <v-layout wrap justify-center>
              <v-flex xs10>
                <v-pagination
                  v-model="currentPage"
                  :length="pageLength"
                  :total-visible="7"
                  circle
                  color="#427D2D"
                  small
                ></v-pagination>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,

      rows: [],
      view: "District",
      unreadCount: 0,

      currentPage: 1,
      count: 10,
      pageLength: 0,

      fromDate: null,
      toDate: null,
      menuFrom: false,
      menuTo: false,
      status: "All",
      district: "All",
      keyword: "",

      statusOptions: ["All", "New", "Pending", "Acknowledged", "In Progress", "Closed"],
      districtOptions: ["All"],
    };
  },
  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
    //admin is the state level view - every district, not a personal inbox
    isStateView() {
      return this.view === "State" || this.userRole === "admin" || this.userRole === "StateMedicalOfficer" || this.userRole === "State Medical Officer";
    },
  },
  watch: {
    currentPage() {
      this.getData();
    },
    fromDate() {
      this.currentPage = 1;
      this.getData();
    },
    toDate() {
      this.currentPage = 1;
      this.getData();
    },
    status() {
      this.currentPage = 1;
      this.getData();
    },
    district() {
      this.currentPage = 1;
      this.getData();
    },
    keyword() {
      this.currentPage = 1;
      this.getData();
    },
  },
  beforeMount() {
    this.getDistricts();
    this.getData();
  },
  methods: {
    getDistricts() {
      axios({
        method: "GET",
        url: "/state/districts",
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
        .then((response) => {
          if (response.data.status && response.data.data) {
            this.districtOptions = ["All"].concat(response.data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getData() {
      this.appLoading = true;
      // "Pending" is a frontend-only concept derived from "New" items older than 24hrs.
      // Send "New" to backend when Pending is selected so we get the right raw data.
      var backendStatus = this.status === "Pending" ? "New" : this.status;
      axios({
        method: "GET",
        url: "/snakebite/alert/list",
        headers: { "x-auth-token": localStorage.getItem("token") },
        params: {
          page: this.currentPage,
          limit: this.count,
          status: backendStatus,
          district: this.district,
          fromDate: this.fromDate,
          toDate: this.toDate,
          keyword: this.keyword,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.view = response.data.view || "District";
            this.unreadCount = response.data.unreadCount || 0;
            this.pageLength = response.data.pages || 0;
            var normalized = this.normalize(response.data.data || []);
            // Client-side filter for Pending / New to separate them precisely
            if (this.status === "Pending") {
              normalized = normalized.filter((row) => this.displayStatus(row) === "Pending");
            } else if (this.status === "New") {
              normalized = normalized.filter((row) => this.displayStatus(row) === "New");
            }
            this.rows = normalized;
          } else {
            this.rows = [];
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    /*
      The district inbox returns alert records with the incident nested, the state view
      returns the incidents directly. Flatten both into one row shape.
    */
    normalize(data) {
      var isState = this.view === "State";
      return data
        .map((item) => {
          var incident = isState ? item : item.snakebite;
          if (!incident) return null;
          return {
            alertId: isState ? null : item._id,
            snakebiteId: incident._id,
            name: incident.name,
            phone: incident.phone || incident.mobileno,
            Districtname: incident.Districtname || incident.district,
            reporteddate: incident.reporteddate,
            responseStatus: incident.responseStatus || "New",
            responseTime: incident.responseTime,
            actionCount: incident.actionCount || 0,
            isUnread: isState ? false : item.isViewed === false,
          };
        })
        .filter(function (row) {
          return row !== null;
        });
    },

    //each role sits under its own layout, so the detail route differs
    detailPath() {
      if (this.$route.path.startsWith("/districtMedical") || this.userRole === "District Medical Officer" || this.userRole === "DistrictMedicalOfficer" || this.userRole === "DMO")
        return "/districtMedical/snakebiteAlertView";
      if (this.$route.path.startsWith("/stateDisaster") || this.userRole === "StateDisasterOfficer" || this.userRole === "State Disaster Officer" || this.userRole === "State Disaster Management Officer")
        return "/stateDisaster/snakebiteAlertView";
      if (this.$route.path.startsWith("/stateMedical") || this.userRole === "StateMedicalOfficer" || this.userRole === "State Medical Officer")
        return "/stateMedical/snakebiteAlertView";
      if (this.$route.path.startsWith("/disaster") || this.userRole === "Disaster Management Officer" || this.userRole === "DisasterManagementOfficer")
        return "/disaster/snakebiteAlertView";
      if (this.$route.path.startsWith("/medicalOfficers") || this.userRole === "MedicalOfficer")
        return "/medicalOfficers/snakebiteAlertView";
      if (this.$route.path.startsWith("/DistrictEmergencyOfficer") || this.userRole === "District Emergency Officer")
        return "/DistrictEmergencyOfficer/snakebiteAlertView";
      return "/snakebiteAlertView";
    },

    openAlert(row) {
      var query = { snakebiteId: row.snakebiteId };
      if (row.alertId) query.id = row.alertId;
      this.$router.push({ path: this.detailPath(), query: query });
    },

    displayStatus(row) {
      if (!row) return "New";
      var status = row.responseStatus || "New";
      if (status === "New") {
        var reportTime = row.reporteddate ? new Date(row.reporteddate).getTime() : null;
        if (reportTime && !isNaN(reportTime)) {
          var now = new Date().getTime();
          var oneDayMs = 24 * 60 * 60 * 1000;
          if (now - reportTime > oneDayMs && (row.actionCount === 0 || !row.actionCount)) {
            return "Pending";
          }
        }
      }
      return status;
    },

    statusTooltip(row) {
      var st = this.displayStatus(row);
      if (st === "Pending") {
        return "Incident reported over 24 hours ago with no action recorded";
      }
      if (st === "New") {
        return "Recently reported incident awaiting response";
      }
      if (st === "Acknowledged") {
        return "Alert viewed & acknowledged by officer";
      }
      if (st === "In Progress") {
        return "Response action currently in progress";
      }
      if (st === "Closed") {
        return "Incident resolved and closed";
      }
      return st;
    },

    statusClass(status) {
      if (status === "Closed") return "status-closed";
      if (status === "In Progress") return "status-progress";
      if (status === "Acknowledged") return "status-ack";
      if (status === "Pending") return "status-pending";
      return "status-new";
    },

    humanize(minutes) {
      if (minutes === null || minutes === undefined || isNaN(minutes)) return "-";
      var total = Math.round(minutes);
      if (total < 60) return total + "m";
      var hours = Math.floor(total / 60);
      var mins = total % 60;
      if (hours < 24) return hours + "h " + mins + "m";
      var days = Math.floor(hours / 24);
      return days + "d " + (hours % 24) + "h";
    },

    formatDateTime(value) {
      if (!value) return "-";
      var d = new Date(value);
      if (isNaN(d.getTime())) return "-";
      var pad = function (n) {
        return n < 10 ? "0" + n : "" + n;
      };
      var h = d.getHours();
      //midnight and noon both read as 12 on a 12-hour clock, not 0
      var hour12 = h % 12 === 0 ? 12 : h % 12;
      return (
        pad(d.getDate()) +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        d.getFullYear() +
        " " +
        pad(hour12) +
        ":" +
        pad(d.getMinutes()) +
        " " +
        (h < 12 ? "AM" : "PM")
      );
    },
  },
};
</script>

<style scoped>
.heading {
  font-family: poppinsregular;
  font-size: 20px;
  font-weight: 900;
}
.subtext {
  font-family: poppinsregular;
  font-size: 12.5px;
  color: #6b7a66;
}
.btntext {
  font-family: poppinsregular;
  font-size: 12px;
}
.tablehead {
  font-family: poppinsregular;
  font-size: 13px !important;
  color: #000 !important;
  text-transform: uppercase !important;
  white-space: nowrap;
}
.tableitems {
  font-family: poppinsregular;
  font-size: 13px;
}
.nodata {
  font-family: poppinsregular;
  font-size: 15px;
  color: #8a998a;
}
.pending-text {
  color: #b26a00;
}
.unread-row {
  background: #f2fbf5;
}
.unread-pill {
  background: #d32f2f;
  color: #fff;
  border-radius: 12px;
  padding: 2px 10px;
  font-family: poppinsregular;
  font-size: 11px;
  vertical-align: middle;
}
.status-chip {
  border-radius: 10px;
  padding: 2px 10px;
  font-size: 11.5px;
  font-family: poppinsregular;
  white-space: nowrap;
}
.status-new {
  background: #fdecea;
  color: #c62828;
}
.status-pending {
  background: #fff4e0;
  color: #b26a00;
}
.status-ack {
  background: #fff4e0;
  color: #b26a00;
}
.status-progress {
  background: #e8f1fd;
  color: #1565c0;
}
.status-closed {
  background: #e8f5e9;
  color: #2e7d32;
}
</style>
